import { useEffect } from "react";
import {
  Emails2025,
  intimationLetters2025,
  IntimationLettersToCMO2025,
  IntimationLettersToDGP2025,
  IntimationLettersToDHS2025
} from "../../constants/constants";
import REACTGA from "react-ga4";
import { ChevronLeft } from "lucide-react";
import { useLocation } from 'react-router-dom';

export const Intimations2025 = () => {
  useEffect(() => {
    REACTGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Intimations Page",
    });
  }, []);
  return (
    <>
      <div className="py-3 w-[90%] flex justify-end mx-auto">
        <button
          className="text-md bg-sky-300 rounded-xl px-3 py-2 flex gap-1"
          onClick={() => (window.location.href = "/")}
        >
          <ChevronLeft />
          Back
        </button>
      </div>
      <div className="flex items-start flex-col ml-3 mr-3 mb-3 navbar-offset mt-[0.5cm]">
        <div className="mx-auto">
          <div className="text-secondary font-extrabold text-2xl md:text-4xl">
            Intimation Letters for BRT 2025-2026:-
          </div>
          <a
            href="https://nhwm-job-portal.s3.ap-south-1.amazonaws.com/Proof+of+posting+of+Letter+for+BRT+2025-26.pdf"
            target="_blank"
            rel="noreferrer"
            className="link text-[#0000ff] font-bold md:text-xl"
          >
            Click here to see Proof of Intimation Letters (Post Office
            Documents)
          </a>
          <br />
          
          
          <div className="font-bold text-xs md:text-sm">
            Personal Contact No of MD has been erased in the scanned copy of
            each Letter for security purpose.
          </div>
          <br />
          <div className="flex flex-col gap-3 md:gap-7">
            {intimationLetters2025.map((item: any, index: any) => (
              <div
                key={index}
                className="collapse collapse-plus bg-[#045cb4] hover:bg-[hsl(210,96%,46%)]"
              >
                <input type="checkbox" />
                <div className="collapse-title text-sm md:text-xl font-medium text-white">
                  {item.title}
                </div>
                <div className="collapse-content">
                   <a href={item.href} rel="noreferrer" target="_blank">
                    <img src={item.href} alt={item.title} />
                  </a> 
                </div>
              </div>
            ))}
          </div>
          <br />
          <div className="font-extrabold text-[1.15rem] md:text-3xl text-[#A70000] text-center">
            Intimation Letters To CMO For BRT 2025-26 :-
          </div>
          <br />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-7">
            {IntimationLettersToCMO2025.map((item: any, index: any) => (
              <div
                key={index}
                className="collapse collapse-plus bg-[#045cb4] hover:bg-[hsl(210,96%,46%)]"
              >
                <input type="checkbox" />
                <div className="collapse-title text-sm md:text-xl font-medium text-white">
                  {item.title}
                </div>
                <div className="collapse-content">
                   <a href={item.href} rel="noreferrer" target="_blank">
                    <img src={item.href} alt={item.title} />
                  </a> 
                </div>
              </div>
            ))}
          </div>
          <br />
           <div className="font-extrabold text-[1.15rem] md:text-3xl text-[#A70000] text-center">
                      Intimation Letters to Director of Health Services For BRT 2025-26 :-
                    </div>
                    <br />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-7">
                      {IntimationLettersToDHS2025.map((item: any, index: any) => (
                        <div
                          key={index}
                          className="collapse collapse-plus bg-[#045cb4] hover:bg-[hsl(210,96%,46%)]"
                        >
                          <input type="checkbox" />
                          <div className="collapse-title text-sm md:text-xl font-medium text-white">
                            {item.title}
                          </div>
                          <div className="collapse-content">
                            <a href={item.href} rel="noreferrer" target="_blank">
                              <img src={item.href} alt={item.title} />
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                    <br />
          <div className="font-extrabold text-[1.15rem] md:text-3xl text-[#A70000] text-center">
            Intimation Letters to Director General of Police For BRT 2025-26 :-
          </div>
          <br />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-7">
            {IntimationLettersToDGP2025.map((item :any, index: any) => (
              <div
                key={index}
                className="collapse collapse-plus bg-[#045cb4] hover:bg-[hsl(210,96%,46%)]"
              >
                <input type="checkbox" />
                <div className="collapse-title text-sm md:text-xl font-medium text-white">
                  {item.title}
                </div>
                <div className="collapse-content">
                  <a href={item.href} rel="noreferrer" target="_blank">
                  <img src={item.href} alt={item.title} />
                  </a> 
                </div>
              </div>
            ))}
          </div>
          <br />
          <div className="font-extrabold text-[1.15rem] md:text-3xl text-[#A70000] text-center">
            Intimation Email to All States' Cyber-cell and CERT-IN Team :-
          </div>
          <br />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-7">
            {Emails2025.map((item :any, index: any) => (
              <div
                key={index}
                className="collapse collapse-plus bg-[#045cb4] hover:bg-[hsl(210,96%,46%)]"
              >
                <input type="checkbox" />
                <div className="collapse-title text-sm md:text-xl font-medium text-white">
                  {item.title}
                </div>
                <div className="collapse-content">
                  <a href={item.href} rel="noreferrer" target="_blank">
                  <img src={item.href} alt={item.title} />
                  </a> 
                </div>
              </div>
            ))}
          </div>
         <br/>
          <div className="text-secondary text-xl md:text-3xl font-bold text-center">
            Come on - Join Us...
          </div>
          <div className="text-secondary text-xl md:text-3xl font-bold text-center">
            We want to see you participating in our MISSION.
          </div>
          <br />
        </div>
      </div>
    </>
  );
};
